import decodeJwt from "jwt-decode";

const guestPages = [
    '#/loginPasswordForgot'
    , '#/loginPasswordReset'
];
function guest() {
    let page = window.location.hash;
    if (page.indexOf('?') > 0) page = page.substring(0, page.indexOf('?'));
    return guestPages.includes(page) ? Promise.resolve('guest') : Promise.reject();
}
export default {
    // called when the user attempts to log in
	login: ({ username, password }) =>  {
        const request = new Request(window.nobid_endpoint+'/users/authenticate', {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            // credentials: 'include', 
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error("Authentication error. Make sure that your Username and Password match.");
                }
                return response.json();
            })
            .then(({ token }) => {
              if (token) localStorage.setItem('token', token);
            });
    },
    // called when the user clicks on the logout button
    logout: () => {
    	const token = localStorage.getItem('token');
    	const request = new Request(window.nobid_endpoint+'/users/logout', {
            method: 'GET',
            // credentials: 'include', 
            headers: new Headers({ 'Authorization': `Bearer ${token}` }),
        })
        fetch(request);
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        window.redirectHomePage = true;
        return Promise.resolve();
    },
    // called when the API returns an error
    checkError: (error) => {
        if (error.status === 401 || error.status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
    	if (error.status === 422) {
    		if (error.body && error.body.message) alert(error.body.message);
    		return Promise.resolve();
    	}
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: ({ status, response }) => {
        return localStorage.getItem('token')
            ? Promise.resolve()
            : guest();
    },
    // called when the user navigates to a new location, to check for permissions / roles
    // getPermissions: () => Promise.resolve(),
    getPermissions: () => {
      const token = localStorage.getItem('token');
      const decodedToken = token ? decodeJwt(token) : {};
      const role = decodedToken.role;
      const resources = decodedToken.resources;
      const preferences = decodedToken.preferences || {};
      return role && resources ? Promise.resolve({role: role, resources: resources, preferences: preferences}) : guest(); 
    }
};
